import { DatePipe } from '@angular/common';
import { booleanAttribute, Component, computed, input } from '@angular/core';
import { MarkdownPipe } from '@medinbox/angular';
import { ChatMessage } from 'livekit-client';

@Component({
  selector: 'app-chat-message',
  imports: [DatePipe, MarkdownPipe],
  templateUrl: './chat-message.html',
  styleUrl: './chat-message.css',
})
export class ChatMessageUI {
  readonly message = input.required<ChatMessage>();
  readonly sentByUser = input(false, { transform: booleanAttribute });
  readonly showTime = input(true, { transform: booleanAttribute });
  readonly bigText = input(false, { transform: booleanAttribute });

  readonly messageClasses = computed(() => {
    const sentByUser = ['text-white', 'bg-mib-primary'];
    const baseClass = ['bg-secondary'];

    let classes: string[];
    if (this.sentByUser()) {
      classes = [...sentByUser, this.bigText() ? 'text-lg' : 'text-md'];
    } else {
      classes = [...baseClass, this.bigText() ? 'text-3xl' : 'text-lg'];
    }
    return classes.join(' ');
  });
}
